import type { MeUser } from "../types";

let currentAuthUser: MeUser | null = null;

export const getAuthSessionUser = () => currentAuthUser;

export const setAuthSessionUser = (user: MeUser | null) => {
  currentAuthUser = user;
};

export const clearAuthSessionUser = () => {
  currentAuthUser = null;
};
